// extracted by css-extract-rspack-plugin
export default {"cls1":"PaperAbstract-cls1_kza","cls2":"PaperAbstract-cls2_pTU PaperAbstract-cls1_kza","variant-dense":"PaperAbstract-variant-dense_fd3","size-md":"PaperAbstract-size-md_lTM"};